<template>
  <div class="main" style="width: 1180px;">
    <a-card>
      <div class="topInfo">
        <div class="buildTit">{{getBuildingData.name}}</div>
        <a-button type="primary" class="ml20" @click="click_creBuildBt(1)">创建新层</a-button>
        <!-- <a-button type="" class="ml20" style="margin-left:auto;" @click="back()">返回</a-button> -->
      </div>
      <div class="buildListWrap" v-if="getBuildingData && getBuildingData.buildingV3FloorVoList.length > 0">
        <div class="buildList" :key="index" v-for="(item,index) in getBuildingData.buildingV3FloorVoList" @click="goFloor(item)">
          <div class="name">{{item.name}}</div>
          <div class="name2">共
            <span class="color63B5FF">{{item.roomNum}}</span>
            个房间,
            <span class="color63B5FF">{{item.bedNum}}</span>
            个床位,
            <span class="color63B5FF">{{item.toiletNum}}</span>个卫生间
          </div>
          <div class="iconAll">
            <a-icon type="form" class="tableIcon"  @click.stop="click_creBuildBt(0,item)"/>
            <img class="mr20" src="../../assets/icon_trashCan_nor.png" alt="" @click.stop="cli_del_icon(item)">
          </div>
        </div>
      </div>

      <!-- 无数据 -->
      <div class="comNoData" v-if="getBuildingData && getBuildingData.buildingV3FloorVoList.length == 0">
        <img src="../../assets/iconFloor.png" alt="">
        <div class="ml10">暂未创建层，可以先尝试创建您的第一层</div>
      </div>


      <!-- 创建层弹窗 -->
      <a-modal :title="creBuildTan_type == 1 ? '创建新层' : '修改层名'" :width="400" v-model="creBuildTan" footer="">
        <div class="radarTanWrap">
          <div class="pb10">最多支持20位字符，不支持特殊符号</div>
          <input :class="['inputList',item.inputListBorRed ? 'inputListBorRed' : '']"  type="text" maxlength="20" placeholder="请输入层名" :key="index" v-for="(item,index) in buildList" v-model="item.buildName" @keyup="inputChangeHandle(item)">
          <div class="addJcy" @click="creBuild()" v-if="creBuildTan_type == 1">
            <img class="jiaImg" src="../../assets/jia.png" alt="">
            <div>一层</div>
          </div>
        </div>
        <div style="margin-top:20px;text-align: right;">
          <el-button @click="creBuildTan = false">取消</el-button>
          <el-button type="primary" @click="sureCreBuild" v-if="creBuildTan_type == 1">创建</el-button>
          <el-button type="primary" @click="sureCreBuild" v-if="creBuildTan_type == 0">修改</el-button>
        </div>
      </a-modal>

      <!-- 创建层到数量限制弹窗 -->
      <a-modal title="" :width="400" v-model="buildMoreCountTan" footer="">
        <p class="delTips pt50">
          <a-icon type="exclamation-circle" />
          每幢楼最多支持30个楼层，需要先删除楼层才能创建新楼层
        </p>
        <div style="margin-top:20px;text-align: right;">
          <el-button type="primary" @click="buildMoreCountTan = false">知道了</el-button>
        </div>
      </a-modal>

      <!-- 删除层弹窗 -->
      <a-modal title="" :width="400" v-model="delBuildTan" footer="">
        <p class="delTips pt50" v-if="!item.hasRelation">
          <a-icon type="exclamation-circle" />
          即将删除层，您确定要删除吗？
        </p>
        <p class="delTips pt50" v-if="item.hasRelation">
          <a-icon type="exclamation-circle" />
          即将删除层，已经建立的位置和设备关系也将解除，您确定要删除吗？
        </p>
        <p class="delTips colorff4d4f" v-if="item.hasConsumer">注意：本次删除包含C端用户的设备，这个操作只会删除在当前机构的位置绑定关系</p>
        <div style="margin-top:20px;text-align: right;">
          <el-button @click="delBuildTan = false">取消</el-button>
          <el-button type="primary" @click="tan_cli_del_icon()">删除</el-button>
        </div>
      </a-modal>
    </a-card>
  </div>
</template>

<script>


export default {
  components: {
    
  },
  data() {
    return {
      buildId: this.$route.query.buildId,
      getBuildingData: '',            //获取楼对象数据
      creBuildTan: false,             //创建层弹窗
      buildList: [{buildName: ''}],
      buildMoreCountTan: false,       //创建层到数量限制弹窗
      delBuildTan: false,             //删除层弹窗
      item: '',                       //当前操作的操作的item
      creBuildTan_type: '',           //1创建层 0修改层
    };
  },
  created() {},
  mounted() {
    this.getBuilding()    //获取楼对象数据
  },
  methods: {
	inputChangeHandle(e){
		e.buildName = e.buildName.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g,'')
	},
    // 获取楼对象
    getBuilding(){
      let param = {
        id: this.buildId,
      }
      this.$get(
        "/api/v3/building/getBuilding",
        param,
        (res) => {
          if (res.code == 0) {
            this.getBuildingData = res.data
            this.$forceUpdate();
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error(err.msg);
        }
      );
    },
    // 点击创建新楼按钮(type 1创建 0修改)
    click_creBuildBt(type,item){
      this.creBuildTan_type = type; //1创建楼 0修改楼
      console.log(type)
      if(type == 1){
        if(this.getBuildingData.buildingV3FloorVoList.length < 30){
          this.buildList = [{buildName: ''}];
          this.creBuildTan = true;
        }else{
          this.buildMoreCountTan = true;
        }
      }else if(type == 0){
        this.item = item;     //当前操作的操作的item
        this.buildList = [{buildName: this.item.name}];
        this.creBuildTan = true;
      }
    },
    // +一层
    creBuild(){
      let nowLength = this.buildList.length + this.getBuildingData.buildingV3FloorVoList.length    //当前一共多少层
      if(nowLength < 30){
        let buildName = { buildName: "" };
        this.buildList.push(buildName);
      }else{
        this.$message.error("每幢楼最多支持30个楼层，需要先删除楼层才能创建新楼层");
      }
    },
    // 创建新楼弹框内点击确定走创建新楼接口
    sureCreBuild(){
      let isCanGo = 0;    //是否能添加 只要循环里有一个有数据即可添加
      for(let i = 0;i < this.buildList.length;i++){
        if(this.buildList[i].buildName){
          isCanGo = 1
          this.buildList[i].inputListBorRed = false;
        }else{
          this.buildList[i].inputListBorRed = true;
        }
      }
      // this.loading = true;
      if(isCanGo != 1){
        this.$forceUpdate()
        return;
      }
      if(this.creBuildTan_type == 1){             //创建楼
        let floorNameList = []
        for(let i = 0;i < this.buildList.length;i++){
          if(this.buildList[i].buildName){
            floorNameList.push(this.buildList[i].buildName)
          }
        }
        let param = {
          buildingId: this.buildId,
          floorNameList: floorNameList,
        };
        this.$post(
          "/api/v3/floor",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.creBuildTan = false;
              this.getBuilding()
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }else if(this.creBuildTan_type == 0){       //修改楼
        let param = {
          buildingId: this.buildId,
          id: this.item.id,
          name: this.buildList[0].buildName,
        }
        this.$put(
          "/api/v3/floor",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.creBuildTan = false;
              this.getBuilding()
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }
    },
    // 点击删除icon
    cli_del_icon(item){
      this.item = item;          //当前操作的操作的item
      this.delBuildTan = true;   //弹窗显示
    },
    // 弹窗内点击删除
    tan_cli_del_icon(){
      let param = {
        hasRelation: this.item.hasRelation,
        id: this.item.id,
      }
      this.$delete(
        "/api/v3/floor/delete",
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.delBuildTan = false;
            this.getBuilding()
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error(err.msg);
        }
      );
    },
    // 进层
    goFloor(item){
      this.$router.push({
        path: "./goFloor?buildId=" + this.getBuildingData.id + '&buildName=' + this.getBuildingData.name + '&floorId=' + item.id + '&floorName=' + item.name,
      });
    },
    back(){
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.main::v-deep {
  padding: 20px 0;
  .ant-card {
    padding: 20px 20px 30px 20px;
    border-radius: 8px;
    .ant-card-body {
      padding: 0;
    }
  }
  .ant-tabs-bar {
    border-bottom: none;
  }
  .topInfo{
    display: flex;
    .buildTit{
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
    }
  }
  .buildListWrap{
    .buildList:hover{
      background: #E6F7FF;
    }
    .buildList{
      width: 1140px;
      height: 45px;
      background: #FFFFFF;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      margin-top: 15px;
      cursor: pointer;
      display: flex;
      align-items: center;
      .name{
        width: 477px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        text-align: right;
      }
      .name2{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        margin-left: 13px;
      }
      .iconAll{
        margin-left: auto;
        display: flex;
        align-items: center;
        .tableIcon {
          color: #1890ff;
          font-size: 20px;
          cursor: pointer;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>